import { Api } from 'api';
import { CRUDResponse } from 'api/interfaces/CRUDResponse';
import { Firm, FirmPayload, FirmType, MPID } from 'api/interfaces/firm';
import { isBusinessUnitsEnabled } from 'config/features';
import { Dispatch } from 'redux';
import { Action } from 'redux/action';
import { createAction } from 'redux/actions/creator';
import { ApplicationState } from 'redux/applicationState';
import { FirmsActions } from 'redux/reducers/firmsReducer';

export const updateFirm =
  (firm: Firm) =>
  (
    dispatch: Dispatch<Action<FirmsActions>>,
    getState: () => ApplicationState,
    api: Api
  ): VoidFunction => {
    dispatch(createAction(FirmsActions.updateFirmStarted));
    const state = getState();
    const selectedBusinessUnit = state.firms.selectedBusinessUnit;
    const { MPIDS } = firm;
    const useBusinessUnits = isBusinessUnitsEnabled && firm.firmType === FirmType.Connectivity;
    const payload = useBusinessUnits
      ? FirmPayload.fromFirmWithBU(firm, selectedBusinessUnit)
      : FirmPayload.fromFirm(firm);

    const task = useBusinessUnits ? api.updateFirmWithBU(payload) : api.updateFirm(payload);

    const newFirm = { ...firm, firmName: MPIDS.map((mpid: MPID): string => mpid.mpid).join(', ') };

    task
      .run()
      .then((result: CRUDResponse): void => {
        if (result.success) {
          dispatch(createAction(FirmsActions.updateFirmCompleted, newFirm));
        } else {
          dispatch(createAction(FirmsActions.updateFirmFailed, result.message));
        }
      })
      .catch((error: Error): void => {
        dispatch(createAction(FirmsActions.updateFirmFailed, error.message));
      });

    return (): void => {
      task.cancel();
    };
  };
